export default __webpack_public_path__ + "static/media/filter.15b584d9.svg";